import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpClientService } from '../../../http/http-client.service';
import { CMSSessionService } from '../../session/cms-session.service';
import { environment } from 'apps/portal/src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CMSSettingsAuthService extends HttpClientService {
  constructor(http: HttpClient, private cmsSessionService: CMSSessionService) {
    super(http);
  }

  auth(): Observable<any> {
    const httpParams = new HttpParams()
      .set('grant_type', 'client_credentials')
      .set('client_id', environment.configSite.CLIENT_ID)
      .set('client_secret', environment.configSite.CLIENT_SECRET)
      .set('scope', 'squidex-api');
    return this.post(
      environment.configSite.endPointAPI + 'identity-server/connect/token',
      httpParams,
      'form'
    );
  }

  setToken(token: string) {
    this.cmsSessionService.setSettingsToken(token);
  }

  getToken() {
    return this.cmsSessionService.getSettingsToken();
  }
}
